import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_acquisition-makersignupwithover11stockists-action_unknown';
/**
 * Emit facebook event when MakerSubmitApplication or MakerAdPageApply events are fired and number of stockists is greater than 11
 */
export function trackBrandAcquisitionMakersignupwithover11Stockists(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'ifMakerApplicationSubmittedGreaterThan11Stockists',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
